// eslint-disable-next-line no-restricted-globals, no-unused-vars
const ignored = self.__WB_MANIFEST;

// Your custom service worker code goes here.
